<template>
  <div class="page-container">
    <el-card class="mb-20">
      <app-filter
        :filter-list="table_filter"
        default-label-width="90px"
        @search="search"
      />
    </el-card>
    <el-card>
      <app-table
        ref="table"
        :table-key="table_key"
        :tablep="table_params"
        :get-data="getBatchCreateLogList"
      />
    </el-card>
    <!-- 详情弹窗 -->
    <el-drawer
      v-if="drawer_config.is_show"
      :visible.sync="drawer_config.is_show"
      :size="500"
    >
      <component
        :is="drawer_config.component_name"
        v-if="drawer_config.is_show"
        v-loading="drawer_config.is_loading"
        v-bind="drawer_config.props"
      />
    </el-drawer>
  </div>
</template>
<script>
import { getMediasListApi } from '@/api/medias';
import {
  getBatchCreateLogListApi,
  getBatchCreateLogDetailApi,
} from '@/api/tool/advertiser-source-template/batch-create-log';
import { CHANNEL_INTERFACE_TYPE } from '@/enums';
import { formDataAssign } from '@/tools/form';

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
    'app-filter': () => import('@/components/app-filter'),
    'app-form': () => import('@/components/app-form'),
    'view-log': () => import('./components/view-log'),
  },
  data() {
    return {
      // 过滤项
      table_filter: require('./model/table-filter')(this),
      // 表头数据
      table_key: require('./model/table-key')(this),
      // 表格请求参数
      table_params: {
        channel_interface: CHANNEL_INTERFACE_TYPE.JRTT,
        page: 1,
        page_size: 10,
      },
      // 行编辑表单配置
      form_data_config: {
        name: {
          name: {
            label: '模板名称',
            type: 'input',
            props: {
              placeholder: '请输入模板名称',
            },
            value: '',
          },
        },
      },
      // 弹窗配置
      drawer_config: {
        is_show: false,
        is_loading: false,
        component_name: null, // 组件名称 - view-log：查看日志
        props: {},
        confirm: () => {},
      },
    };
  },
  async created() {
    this.table_filter.advertiser_id.options = await this.getAdvertiserList(CHANNEL_INTERFACE_TYPE.JRTT);
  },
  methods: {
    /**
     * 搜索
     * @param {Object} params 查询参数
     * @returns {void}
     */
    search(params) {
      Object.assign(this.table_params, params);
      this.$refs.table.seekTable();
    },
    /**
     * 查看日志
     * @param {number} id 当前模板ID
     * @returns {void}
     */
    async onView(id) {
      try {
        Object.assign(this.drawer_config, {
          is_show: true,
          is_loading: true,
          component_name: 'view-log',
          props: {
            descriptionsConfig: require('./model/view-log-descriptions-config.js')(this),
            tableKey: require('./model/view-log-table-key.js')(this),
            tableData: [],
          },
          confirm: () => {
            this.drawer_config.is_show = false;
          },
        });

        const detail_data = await getBatchCreateLogDetailApi(id);
        const {
          advertiser,
          advertiser_id,
          name,
          advertiser_source_type,
          status,
          result,
          details,
        } = detail_data;
        const descriptions_config = {
          advertiser,
          advertiser_id,
          name,
          advertiser_source_type,
          status,
          result,
        };
        formDataAssign(this.drawer_config.props.descriptionsConfig, descriptions_config);
        this.drawer_config.props.tableData.push(...details);
      } finally {
        this.drawer_config.is_loading = false;
      }
    },
    /**
     * 获取批量创建日志列表
     * @param {Object} params 过滤参数
     * @returns {Promise<Object>}
     */
    getBatchCreateLogList(params) {
      const { name, ...rest } = params;
      return new Promise((resolve, reject) => {
        getBatchCreateLogListApi({
          filtering: {
            advertiser_source_type: 'native_anchor',
            ...(name && { name }),
          },
          ...rest,
        }).then(resolve).catch(reject);
      });
    },
    /**
     * 获取广告主账号列表
     * @param {string} type 渠道接口
     * @returns {Promise<Object[]>}
     */
    getAdvertiserList(type) {
      return new Promise((resolve, reject) => {
        getMediasListApi({
          type,
          is_list: true,
        }).then(res => {
          const result = res.list.map(({ advertiser_id, advertiser_name, note }) => {
            return {
              label: `${advertiser_id}（${advertiser_name}）${note ? ' - ' + note : ''}`,
              value: advertiser_id,
            };
          });
          resolve(result);
        }).catch(reject);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-drawer__body {
  padding: 0 0 77px 0;
}
label {
  padding-right: 12px;
  text-align: right;
  width: 100px;
  line-height: 28px;
  font-size: 14px;
  color: #606266;
}
.el-icon-remove-outline:hover {
  color: #F56C6C;
}
</style>
